import Footer from "../components/footer/footer";
import Hero from "../components/ai-prof/hero";
import Scope from "../components/ai-prof/scope";
import Background from "../components/ai-prof/background";
import HowWeHelp from "../components/ai-prof/howWeHelp"
import Apply from "../components/ai-prof/apply";

export default function AIProf() {
  return (
    <>
      <Hero />
      <Scope />
      <Background />
      <HowWeHelp />
      <Apply />
      <Footer />
    </>
  );
}